import { useAuth } from '@workos-inc/authkit-react';
import type { Permission, Role } from '@property/shared';

/**
 * Reads the role and permissions WorkOS embeds in the active session and exposes
 * a `can(permission)` helper for gating UI. The backend remains the source of
 * truth — this only avoids showing actions that would be rejected with 403.
 */
export function usePermissions() {
  const { role, permissions, isLoading, user } = useAuth();

  const can = (permission: Permission): boolean => permissions.includes(permission);

  return {
    role: (role ?? undefined) as Role | undefined,
    permissions: permissions as Permission[],
    can,
    isLoading,
    userId: user?.id as string | undefined,
  };
}
